import axios from 'axios';

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

function createApi(tokenKey) {
  const instance = axios.create({ baseURL: BASE_URL });
  instance.interceptors.request.use((config) => {
    const token = localStorage.getItem(tokenKey);
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
  return instance;
}

// Unauthenticated instance — used by the shared time-clock kiosk (identity is the punched PIN).
export const publicApi = axios.create({ baseURL: BASE_URL });

export const customerApi = createApi('tiffin_customer_token');
export const staffApi = createApi('tiffin_staff_token');
export const portalApi = createApi('tiffin_portal_token');
export const posApi = createApi('tiffin_pos_token');

export function formatApiError(err) {
  return err?.response?.data?.error || err?.message || 'Something went wrong. Please try again.';
}

// Fetch an auth-protected file as a blob (img/link tags can't send the Authorization header, so we
// stream it through the axios instance). By default opens it in a new tab; pass { returnUrl: true }
// to get the blob URL back instead (e.g. to render inline in an <img>).
export async function viewProtectedFile(api, url, opts = {}) {
  const res = await api.get(url, { responseType: 'blob' });
  const blobUrl = URL.createObjectURL(res.data);
  if (opts.returnUrl) return blobUrl;
  window.open(blobUrl, '_blank', 'noopener');
  setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
  return blobUrl;
}
